var b = function(r) {
  return l(r) && !u(r);
};
function l(e) {
  return !!e && typeof e == "object";
}
function u(e) {
  var r = Object.prototype.toString.call(e);
  return r === "[object RegExp]" || r === "[object Date]" || j(e);
}
var y = typeof Symbol == "function" && Symbol.for, g = y ? Symbol.for("react.element") : 60103;
function j(e) {
  return e.$$typeof === g;
}
function A(e) {
  return Array.isArray(e) ? [] : {};
}
function f(e, r) {
  return r.clone !== !1 && r.isMergeableObject(e) ? c(A(e), e, r) : e;
}
function m(e, r, n) {
  return e.concat(r).map(function(a) {
    return f(a, n);
  });
}
function s(e, r, n) {
  var a = {};
  return n.isMergeableObject(e) && Object.keys(e).forEach(function(t) {
    a[t] = f(e[t], n);
  }), Object.keys(r).forEach(function(t) {
    !n.isMergeableObject(r[t]) || !e[t] ? a[t] = f(r[t], n) : a[t] = c(e[t], r[t], n);
  }), a;
}
function c(e, r, n) {
  n = n || {}, n.arrayMerge = n.arrayMerge || m, n.isMergeableObject = n.isMergeableObject || b;
  var a = Array.isArray(r), t = Array.isArray(e), i = a === t;
  return i ? a ? n.arrayMerge(e, r, n) : s(e, r, n) : f(r, n);
}
c.all = function(r, n) {
  if (!Array.isArray(r))
    throw new Error("first argument should be an array");
  return r.reduce(function(a, t) {
    return c(a, t, n);
  }, {});
};
var M = c;
export {
  M as d
};
